import { css } from "@emotion/core"
import { theme } from "../constants"

export const errorTextStyles = css`
  font-size: ${theme.fontSizes[2]};
  color: ${theme.colors.danger};
`

export const inputStyles = (hasError) => css`
  ${theme.presets.flexColumn};
  max-height: 44px;
  padding: 12px 20px;
  background-color: ${theme.colors.purple[800]} !important;
  color: ${theme.colors.text};
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes[4]};
  border-radius: ${theme.radii[11]};
  border: 1px solid ${hasError ? theme.colors.danger : theme.colors.purple[800]};
  box-shadow: ${theme.shadows.regular};

  &:disabled {
    opacity: 0.3;
    background: ${theme.colors.purple[900]} !important;
    color: ${theme.colors.text} !important;
    border: none;
    box-shadow: none;
    &:hover {
      border: none;
    }
  }

  &:hover,
  &:focus,
  &:active {
    border: 1px solid
      ${hasError ? theme.colors.danger : theme.colors.purple[400]}; //reverting, shushma raised bugs
    box-shadow: ${theme.shadows.regular} !important;
  }

  &::placeholder {
    color: ${theme.colors.grey[400]};
  }
  &:read-only {
    opacity: 0.3;
    background: ${theme.colors.purple[800]};
  }
`
export const inputContainerStyles = css`
  position: relative;
  font-family: ${theme.fonts.primary};
  ${theme.presets.flexColumn};
  ${theme.presets.flexXYCentered};

  .error-text {
    margin-top: 8px;
    margin-left: 4px;
    text-align: left;
    width: 95%;
    ${errorTextStyles}
  }
`
export const loading = css`
  position: absolute;
  right: 5px;
  width: 40px;
`
export const editIcon = css`
  position: absolute;
  color: ${theme.colors.text};
  font-size: 20px;
  right: 10px;
  cursor: pointer;
`
export const tickIcon = css`
  position: absolute;
  right: 8px;
  background: transparent;
  mix-blend-mode: normal;
  width: 30px;
  height: 30px;
  cursor: pointer;
  background: ${theme.colors.purple[400]};
  border-radius: 45.5px;
  padding: 3px 7px;
`
export const tickImg = css`
  width: 13px;
`
export const storybookInput = css`
  input.ant-input {
    width: 97%;
  }
`
